import {envUtil} from '@/helper/env';

export const LINKS = {
  PHEMEX_CONTRACT_TRADE: '/futures',
  PHEMEX_CONTRACT_INVERSE_TRADE: '/futures/inverse',
  PHEMEX_PILOT_CONTRACT_TRADE: '/onchain/derivatives',
  PHEMEX_CONTRACT_TRADE_USDS: '/futures/BTC-USDT',
  PHEMEX_CONTRACT_TRADE_USDS_MARTIN: '/futures/BTC-USDT?t=s&type=contract_martin',
  MOC_PHEMEX_CONTRACT_TRADE_USDS: '/moc/trade/BTCMUSDT',
  PHEMEX_SPOT_MARGIN_TRADE: '/margin/trade',
  PHEMEX_SPOT_TRADE: '/spot/trade', //symbol一定不能带‘-’，否则无法重定向
  SPOT_TRADE: '/trade', // 配合新规则 trade/BTC-USDT
  PHEMEX_MEME_TRADE: '/onchain/trade',
  PHEMEX_MEME_TRADE_SOLANA_SPYX: '/onchain/trade/Solana-XsoCS1TfEyfFhfvj8EtZ528L3CaKBDBRqRapnBbDF2W',
  PHEMEX_TRADE_ALL: '/trade/all',
  PHEMEX_KOL: '/kol/home',
  STRATEGY_DETAIL: '/bot-detail',
  VIP_PORTAL: '/vip-portal',

  // CMS
  PHEMEX_REFERENCES: '/support',
  PHEMEX_BLOG: '/blogs',
  PHEMEX_USER_GUIDES: '/user-guides',
  PHEMEX_GETTING_STARTED: '/getting-started',
  PHEMEX_HELP_CENTER: '/help-center',
  PHEMEX_ACADEMY: '/academy',
  PHEMEX_REFERENCES_ANNOUNCEMENTS: '/announcements',
  PHEMEX_30D_LV3_ANNOUNCEMENTS: '/announcements/limited-time-discount-on-your-new-spot-trading-fees',
  PHEMEX_P2P_MERCHANT_ANNOUNCEMENTS: '/announcements/hot-recruits-be-a-p2p-merchant',
  PHEMEX_REFERENCES_PRIVACY_POLICY: '/help-center/phemex-privacy-policy',
  PHEMEX_REFERENCES_ASSETS_SECURITY: '/help-center/assets-security',
  PHEMEX_REFERENCES_WITHDRAWAL_PROCESS: '/help-center/how-do-i-make-a-withdrawal-web',
  PHEMEX_REFERENCES_GOOGLE_2FA: '/help-center/how-do-i-enable-google-two-factor-authentication',
  PHEMEX_REFERENCES_TERMS_OF_USE: '/help-center/phemex-terms-of-use',
  PHEMEX_OTC_SERVICE: '/help-center/what-is-the-phemex-otc-service',
  PHEMEX_USE_OTC_SERVICE: '/help-center/how-do-i-use-the-phemex-otc-service',
  SUPPORT_DEPOSIT: '/help-center/how-do-i-make-a-deposit-web',
  MADE_AN_INCORRRECT_DEPOSIT: '/help-center/what-can-i-do-if-i-made-an-incorrect-deposit',
  WHY_HASNT_MY_DEPOSIT_BEEN_CREDITED_YET_WEB: '/help-center/why-hasnt-my-deposit-been-credited-yet-web',
  WHY_HASNT_MY_DEPOSIT_BEEN_CREDITED_YET_WEB_WHAT_CAN_I: '/help-center/what-can-i-do-if-i-made-an-incorrect-deposit',
  CASHBACK_VOUCHERS_AND_CARDS: '/help-center/what-are-cashback-vouchers-and-cards',
  PHEMEX_BONUS_TERMS_AND_CONDITIONS: '/help-center/phemex-bonus-terms-and-conditions',
  SUPPORT_SPOT_TRADING: '/blogs/spot-trading-vs-futures-trading',
  SUPPORT_MARGIN_TRADING: '/blogs/bitcoin-margin-trading-on-phemex',
  SUPPORT_HODL: '/blogs/hodl-meaning-how-to-hodl',
  SUPPORT_XRP: '/blogs/what-is-ripple-xrp',
  SUPPORT_BUY_WITH_BITCOIN: '/blogs/what-can-you-buy-with-bitcoin',
  SUPPORT_DOGECOIN: '/academy/what-is-dogecoin',
  SUPPORT_BITCOIN: '/academy/what-is-bitcoin',
  SUPPORT_SHIBA: '/academy/what-is-shiba-inu',
  SUPPORT_ADA: '/academy/what-is-cardano-ada',
  SUPPORT_DOGECOIN_VS_SHIBA: '/academy/dogecoin-vs-shiba-inu',
  SUPPORT_BLOCKCHAIN_TECHNOLOGY: '/academy/what-is-blockchain-technology',
  SUPPORT_BCH: '/academy/what-is-bitcoin-cash-bch',
  SUPPORT_DOT: '/academy/what-is-polkadot-coin',
  SUPPORT_DENT: '/academy/what-is-dent-crypto',
  SUPPORT_DECENTRALIZED_EXCHANGES_DEXS: '/academy/what-are-decentralized-exchanges-dexs',
  SUPPORT_MARKET_MAKER_AMM: '/academy/what-is-an-automated-market-maker-amm',
  SUPPORT_ETHEREUM_LAYER: '/academy/what-are-ethereum-layer-2-solutions',
  SUPPORT_SOL_VS_ETH: '/academy/solana-vs-ethereum-sol-eth',
  SUPPORT_SOL: '/academy/what-is-solana-sol-coin',
  SUPPORT_AVAX: '/academy/what-is-avalanche-avax-crypto',
  SUPPORT_HEDERA_HASHGRAPH: '/academy/hedera-hashgraph',
  SUPPORT_LRC: '/academy/what-is-loopring-lrc',
  SUPPORT_MANA: '/academy/what-is-mana-decentraland',
  SUPPORT_MANA_VS_SAND: '/academy/decentraland-mana-vs-sandbox-sand',
  SUPPORT_TRX: '/academy/what-is-tron-trx',
  SUPPORT_ZEC: '/academy/what-is-zcash-zec',
  SUPPORT_MATIC: '/academy/what-is-polygon-matic',
  SUPPORT_SANDBOX: '/academy/what-is-the-sandbox-blockchain-game',
  SUPPORT_USDC: '/academy/what-is-usdc',
  SUPPORT_XLM: '/academy/stellar-lumens-xlm',
  SUPPORT_BTC_VS_ETH_VS_LTC: '/academy/bitcoin-vs-ethereum-vs-litecoin',
  SUPPORT_LTC: '/academy/what-is-litecoin-ltc',
  SUPPORT_ALGO: '/academy/what-is-algorand-algo',
  SUPPORT_XTC: '/academy/what-is-tezos-xtz',
  SUPPORT_HOW_CRYPTO_RESEARCH: '/academy/how-to-do-crypto-research',
  SUPPORT_TRADE_CRYPTO: '/academy/how-to-trade-crypto',
  SUPPORT_DO_YOUR_OWN_RESEARCH: '/academy/dyor-do-your-own-research',
  SUPPORT_TOKENS_NFTS: '/academy/what-are-non-fungible-tokens-nfts',
  SUPPORT_TECHNICAL_ANALYSIS: '/academy/technical-analysis',
  SUPPORT_SMART_CONTRACTS: '/academy/what-is-ethereum-eth-smart-contracts',
  SUPPORT_CRYPTO_AIRDROP: '/academy/what-is-a-crypto-airdrop',
  SUPPORT_OTC: '/help-center/supported-countries-regions-for-phemex-otc-services',
  PHEMEX_PRIVACY_POLICY: '/help-center/phemex-privacy-policy',
  PHEMEX_BONUS_TERMS: '/help-center/phemex-bonus-terms-and-conditions',
  PHEMEX_ALL_STAR_ANNOUNCEMENTS: '/announcements/updates-to-the-phemex-referral-program',
  PHEMEX_WELCOME_BONUS_RESTRICTIONS: '/announcements/new-welcome-bonus-and-restrictions',
  LISTING_APPLICATION: '/announcements/listing-application',
  LISTING_APPLICATION_DE: '/announcements/bewerbung-fur-neue-listing',
  LISTING_SUGGESTIONS: '/announcements/listing-suggestions',
  LISTING_SUGGESTIONS_DE: '/announcements/empfehlung-fur-neue-listings',
  PHEMEX_HOW_DO_I_MAKE_WITHDRAWAL: '/help-center/how-do-i-make-a-withdrawal-web',
  PHEMEX_HOW_DO_I_MAKE_INTERNAL_WITHDRAWAL: '/help-center/how-do-i-make-an-internal-send-web',
  PHEMEX_HOW_DO_I_USE_THE_CRYPTO_CONVERTER: '/help-center/how-do-i-use-the-crypto-converter',
  PHEMEX_WHATS_IS_THE_CRYPTO_CONVERTER: '/help-center/whats-is-the-crypto-converter',
  PHEMEX_HOW_DO_I_BUY_OR_SELL_COIN: '/help-center/how-do-i-buy-or-sell-a-coin-spot-trading',
  COPY_TRADE_ENTRY: '/academy/what-is-copy-trading',
  COPY_TRADE_PROFIT_SHARING_RULES: '/help-center/copy-trade-profit-sharing-rules',
  PHEMEX_HOW_DO_I_PLACE_A_PERPETUAL_CONTRACT_ORDER: '/help-center/how-do-i-place-a-perpetual-contract-order',
  TAX_REPORTING_HELP_CENTER: '/announcements/use-cointracking-and-koinly-for-easy-crypto-tax-reporting',
  TAX_REPORTING_DOWNLOAD_ARTICAL: '/help-center/how-do-i-download-phemex-account-statements-reports',
  CREDIT_CARD_PAYMENT: '/help-center/credit-card-payment-terms-of-use',
  CREDIT_CARD_PRIVACY: '/help-center/data-privacy-policy',

  PHEMEX_TESTNET: 'https://testnet.phemex.com',

  PHEMEX_API_DOC: 'https://phemex-docs.github.io/#overview',
  ACCOUNT: '/help-center/how-do-i-verify-my-account-kyc',
  // social
  PHEMEX_FACEBOOK: 'https://www.facebook.com/Phemex.official',
  PHEMEX_FACEBOOK_KO: 'https://www.facebook.com/PhemexKorea/',
  PHEMEX_FACEBOOK_DE: 'https://www.facebook.com/PhemexTradingakademie',
  PHEMEX_FACEBOOK_ES: 'https://www.facebook.com/Phemex-en-Español-103459348698599',
  PHEMEX_FACEBOOK_VI: 'https://www.facebook.com/phemexvietnam/',

  PHEMEX_TELEGRAM: 'https://t.me/Phemex_EN',
  PHEMEX_TELEGRAM_JA: 'https://t.me/Phemex_Japanese',
  PHEMEX_TELEGRAM_RU: 'https://t.me/Phemex_Russian',
  PHEMEX_TELEGRAM_KO: 'https://t.me/Phemex_Korea',
  PHEMEX_TELEGRAM_DE: 'https://t.me/Phemex_German',
  PHEMEX_TELEGRAM_TR: 'https://t.me/Phemex_Turkey',
  PHEMEX_TELEGRAM_ES: 'https://t.me/Phemex_Spanish',
  PHEMEX_TELEGRAM_PT: 'https://t.me/phemexbrasil',
  PHEMEX_TELEGRAM_VI: 'https://t.me/phemexvietnam',

  PHEMEX_TWITTER: 'https://x.com/Phemex_official',
  PHEMEX_TWITTER_RU: 'https://x.com/PhemexR',
  PHEMEX_TWITTER_KO: 'https://x.com/Phemex_official',
  PHEMEX_TWITTER_JA: 'https://x.com/PhemexJapan',
  PHEMEX_TWITTER_PULSE: 'https://x.com/PhemexJapan',
  PHEMEX_TWITTER_ES: 'https://x.com/Phemex_official',
  PHEMEX_TWITTER_DE: 'https://x.com/Phemex_official',
  PHEMEX_TWITTER_FR: 'https://x.com/Phemex_official',
  PHEMEX_TWITTER_TR: 'https://x.com/Phemex_official',
  PHEMEX_TWITTER_PT: 'https://x.com/Phemex_official',
  PHEMEX_TWITTER_VI: 'https://x.com/Phemex_official',

  PHEMEX_INSTAGRAM_TR: 'https://www.instagram.com/phemexturkey/',
  PHEMEX_INSTAGRAM_EN: 'https://www.instagram.com/phemexofficial/?hl=en',
  PHEMEX_INSTAGRAM_RU: 'https://www.instagram.com/phemexrussia/',
  PHEMEX_INSTAGRAM_DE: 'https://www.instagram.com/phemexdeutsch/',
  PHEMEX_INSTAGRAM_ES: 'https://www.instagram.com/phemexinspanish/',
  PHEMEX_INSTAGRAM_VI: 'https://www.instagram.com/phemexvietnam/',

  PHEMEX_YOUTUBE: 'https://www.youtube.com/channel/UCtPeiP4cn2K19fH3y7o2tOg',
  PHEMEX_YOUTUBE_ES: 'https://www.youtube.com/channel/UCx1KHENKH77ZwR-ri02yIgg',

  PHEMEX_TIKTOK_ES: 'https://www.tiktok.com/@phemexspanish',

  PHEMEX_MEDIUM: 'https://medium.com/@phemex.com',

  PHEMEX_LINKEDIN: 'https://www.linkedin.com/company/phemex',
  PHEMEX_KAKAO_KO: 'https://open.kakao.com/o/gq7qQ5Sb',
  PHEMEX_NAVER_KO: 'https://blog.naver.com/phemex2019',
  PHEMEX_VK_RU: 'https://vk.com/phemex_official',
  PHEMEX_SNAP_CHAT_EN: 'https://www.youtube.com/watch?v=4uoW6FIktnI&feature=youtu.be&ab_channel=Phemex',
  PHEMEX_SNAP_CHAT_CN: 'https://www.bilibili.com/video/BV16v4111711?from=search&seid=15351043342164340238',

  PHEMEX_MICROBLOG: 'https://www.weibo.com/u/7444696088?is_all=1',
  PHEMEX_DISCORD: 'https://discord.gg/phemexiaofficial',
  PHEMEX_TV: 'https://www.tradingview.com/broker/Phemex/',

  // forms
  PHEMEX_BONUS_FORM: 'https://docs.google.com/forms/d/e/1FAIpQLSeF9Nyb6FBy5LDOTDb0TElBbFeSBgFHWYr7h7d9T-NzAvK5tw/viewform',
  PHEMEX_BONUS_FORM_RU: 'https://docs.google.com/forms/d/e/1FAIpQLScsroRESn5jDqX2Ibu7rG6x3zJJW4-Jxz-T_HRqEDXgXooppA/viewform',
  PHEMEX_BONUS_FORM_KO: 'https://docs.google.com/forms/d/e/1FAIpQLSc2BmasFy3CqRDtuFJmDhZqNkApOZoDQcZcuwvFWApoCGjzyg/viewform',
  PHEMEX_BONUS_FORM_JA: 'https://docs.google.com/forms/d/1AwQ1fivsnjWeEZlS_UO9mL4DjRlSsxn_UqyrlRyIdlg/viewform?ts=5e79c875&edit_requested=true',
  PHEMEX_BONUS_FORM_JOIN_KO: 'https://docs.google.com/forms/d/e/1FAIpQLSe8drStyQo6VBhPNgUFOp2ReaDofGtqCk811C-rlZnuKfrX3g/viewform',
  PHEMEX_C2C_TAKER_FORM_EN: 'https://docs.google.com/forms/d/1HnLA_vvjn0yO5yu4BCD-gHpHW4Ujo7yBP4ewH5WE9dE/viewform',
  PHEMEX_C2C_TAKER_FORM_RU: 'https://docs.google.com/forms/d/e/1FAIpQLScEkMGmwx5KCgaJ-o9sUOKunnopkjYZ4nC3KLOwNP77HwtDfw/viewform',
  PHEMEX_C2C_TAKER_FORM: 'https://docs.google.com/forms/d/e/1FAIpQLSdm0MdJYbDAIKPYcC-MJyqjCAgRnp8IBW1sYjnbvuCVdivcHQ/viewform',
  PHEMEX_CUSTOMER_SERVICE: 'https://phemex.zendesk.com/hc/en-us/requests/new',

  COINMARKETCAP_LINK: 'https://coinmarketcap.com/exchanges/phemex',
  COINGECKO_LINK: 'https://www.coingecko.com/en/exchanges/phemex',
  COINCODEX_LINK: 'https://coincodex.com/exchange/phemex/',
  TRADINGVIEW_LINK: 'https://www.tradingview.com/broker/Phemex/',

  GOOGLE_FORMS_EN: 'https://docs.google.com/forms/d/e/1FAIpQLSd36WmWAnMKxHgqZ4YGdRArxEF8KqoGOhJLEHcoBGaMOk3hfQ/viewform',
  GOOGLE_FORMS_ES: 'https://docs.google.com/forms/d/e/1FAIpQLScZI0BRhzU6tNSTX87B4JfyyVxesI6hJf945ygznKTO4OldXQ/viewform',
  GOOGLE_FORMS_JA: 'https://docs.google.com/forms/d/e/1FAIpQLSeAoyMHVh4qKapOAd6v3fVETM3ps81vJdVN4ftd6tn9CTI_9Q/viewform ',
  GOOGLE_FORMS_RU: 'https://docs.google.com/forms/d/e/1FAIpQLSdyFrmfs8zw8SujU0a69zhEBtL-a2SoteaHx1vacKRfYPJwrQ/viewform ',
  GOOGLE_FORMS_KO: 'https://docs.google.com/forms/d/e/1FAIpQLSc2BmasFy3CqRDtuFJmDhZqNkApOZoDQcZcuwvFWApoCGjzyg/viewform',
  QQ_FORMS_CN: 'https://www.wjx.top/vj/wqxTfsK.aspx',

  // Trading Competition
  TRADING_COMPETITION_CRYPTOBRIEFING: 'https://cryptobriefing.com/up-to-750000-in-btc-up-for-grabs-in-phemex-trading-competition/',
  TRADING_COMPETITION_BITCOINIST: 'https://bitcoinist.com/phemexs-3rd-traders-arena-returns-with-bitcoin-prices-money-and-glory/',
  TRADING_COMPETITION_NEWSBTC: 'https://www.newsbtc.com/news/company/phemex-to-launch-its-3rd-edition-of-the-traders-arena-how-to-win-up-to-750k/',
  TRADING_COMPETITION_COINGAPE: 'https://coingape.com/phemex-traders-arena-version-3-heres-need-know/',
  TRADING_COMPETITION_BLOCKONOMI: 'https://blockonomi.com/the-third-phemex-pt-arena-race-for-glory-set-to-deliver-epic-prizes/',
  TRADING_COMPETITION_CRYPTONEWS: 'https://cryptonews.com/news/race-for-glory-on-phemex-trader-s-arena-iii-up-to-750k-on-th-10596.htm',
  TRADING_COMPETITION_AMBCRYPTO: 'https://ambcrypto.com/race-for-glory-on-phemex-traders-arena-iii-up-to-750k-on-the-line/',
  TRADING_COMPETITION_CRYPTODAILY: 'https://cryptodaily.co.uk/2021/06/race-for-glory-on-phemex-trader-s-arena',
  TRADING_COMPETITION_BTCMANAGER: 'https://btcmanager.com/race-for-glory-phemex-traders-arena-iii-up-to-750k-on-the-line/',
  TRADING_COMPETITION_BEINCRYPTO: 'https://beincrypto.com/race-for-glory-on-phemex-traders-arena-iii/',
  TRADING_COMPETITION_COINNESS: 'https://kr.coinness.com/news/977230',
  TRADING_COMPETITION_UZMANCOIN: 'https://uzmancoin.com/phemex-traders-arena-3-basliyor-takimlar-750-bin-dolar-icin-yarisacak/',
  TRADING_COMPETITION_ALTCOINLOG: 'https://altcoinlog.com/pt-arena-3-race-for-glory/',
  TRADING_COMPETITION_COINREADERS: 'https://www.coinreaders.com/11142',
  TRADING_COMPETITION_COINKOLIK: 'https://www.coinkolik.com/pt-arena-3-750-000-icin-yarisin/',

  TRADING_COMPETITION_BITSMEDIA: 'https://bits.media/',
  TRADING_COMPETITION_CRIPTONOTICIAS: 'https://www.criptonoticias.com/',
  TRADING_COMPETITION_COINTELEGRAPH: 'https://cointelegraph.com/',
  TRADING_COMPETITION_DIARIOBITCOIN: 'https://www.diariobitcoin.com/',
  PHEMEX_ANNIVERSARY: 'https://anniversary.phemex.com',
  PHEMEX_TR: 'https://phemex.com.tr/',
  PHEMEX_TR_DOWNLOAD: 'https://phemex.com.tr/indir',
  PHEMEX_JOBS: 'https://www.linkedin.com/company/phemex/jobs/',

  ONFIDO_INFORMATION_SECURITY: 'https://onfido.com/privacy/#Information%20Security',
  OVERVIEW_IDENTITY_VERIFICATION: '/help-center/what-is-kyc-on-phemex-identity-verification',

  FEEDBACK: 'https://phemex.zendesk.com/hc/en-us/requests/new',
  EDUCATION: 'https://www.youtube.com/embed/EubnhoQVVjo',
  LAUNCH_POOL_WEBSITE: 'https://www.vlaunch.com/',
  LAUNCH_POOL_RULES: 'https://phemex.com/announcements',

  LAUNCH_PAD_YOUTUBE: 'https://www.youtube.com/watch?v=hOtrd2BFR_w',

  ZERO_FEE_RULE: 'https://phemex.com/announcements/celebrate-phemex-3rd-anniversary-with-zero-fee-spot-trading',

  // all-star
  ALL_STAR_VIDEO_ID: 'S_ipJMLGILA',
  ALL_STAR_VIDEO_ID_JA: '4q2JdlXsS2U',

  // price page 详情
  PRICE_PAGE_DETAIL: '/markets/price/',
  KEVIN_FEKBV_FILL_OUT: 'https://gleam.io/FekbV/phemex-3rd-anniversary-celebrate-with-kevin-de-bruyne',
  KEVIN_FEKBV_PLAY: 'https://www.instagram.com/ar/1503485796786888/',
  USER_GUIDE_ON_VOUCHERS: 'https://phemex.com/help-center/what-are-cashback-vouchers-and-cards',
  ALL_STAR_ANNOUNCEMENT: '/announcements/november-referral-friends-get-up-to-350-airdrop-per-referral',

  APP_STORE_LINK: 'https://itunes.apple.com/us/app/itunes-u/id6444693051',
  SWITCH_REGIONS_LINK: 'https://support.apple.com/en-us/HT201389',

  Web3PhemexTokenXPT: 'https://phemex.gitbook.io/phemex-web3-whitepaper/phemex-token/xpt',
  Web3Whitepaper: 'https://phemex.gitbook.io/phemex-web3-whitepaper/',
  WEB3WHITEPAPER_TOKEN_BENEFITS: 'https://phemex.gitbook.io/phemex-web3-whitepaper/features/phemex-token/token-benefits',
  WEB3WHITEPAPER_PHEMEX_TOKEN: 'https://phemex.gitbook.io/phemex-web3-whitepaper/features/phemex-token',

  MOCK_TRADE: '/moc/trade/ETHMUSDT',
  DEPOSIT_WITHDRAW_ZENDESK: 'https://phemex.zendesk.com/hc/en-us/requests/new?ticket_form_id=900001357503',
  HOW_TO_USE_FUTURES_GRID: '/help-center/how-to-use-futures-grid-trading-bots-on-phemex-web',
  WITHDRAW_ADDRESS: 'https://space.id/',
  CHAINLINK: 'https://docs.chain.link/vrf/v2/introduction',
  TERMS_AND_CONDITIONS_LINK: 'https://phemex.com/announcements/invite-your-friends-and-earn-up-to-5100-phemex-tokens',
  SOUL_PASS: '/web3/soulpass',

  MAKET_MAKER: 'https://phemex.com/announcements/phemex-market-maker-program-is-here-calling-all-liquidity-providers',
  UPDATE_PHEMEX_TOKEN: '/announcements/updates-on-phemex-token-launch-and-xpt-pre-mining-stage-4',
  HOW_CAN_SET_SPOT_GRID: '/help-center/how-can-i-set-my-spot-grid-trading-bot-on-phemex-web',
  HOW_CAN_SET_CONTRACT_MARTINGALE: '/help-center/how-to-use-futures-martingale-trading-bots-on-phemex-web',
  COPY_TRADE_AGREEMENT: '/help-center/phemex-user-copy-trade-agreement',
  COPY_TRADE_SHARE_RULE: '/help-center/copy-trade-profit-sharing-rules',
  MAINTENANCE_MARGINS: '/help-center/what-are-initial-and-maintenance-margins',
  HOW_TO_ENABLE_WITHDRAWAL: 'https://phemex.com/help-center/how-to-enable-withdrawal-whitelist-new-address-lock(web)',
  FREQUENTLY_ASKED_QUESTIONS_WITHDRAWALS: 'https://phemex.com/help-center/FAQ-on-withdrawals',
  WEB3_APPLY_MODERATOR_RULE_MORE: 'https://phemex.com/announcements/pulse-next-generation-become-a-moderator-and-curate-your-community-for-rewards',
  HOW_TO_USE_PHEMEX: '/help-center/how-do-i-download-phemex-account-statements-reports',
  WEB3_PULSE_PT_REWARDS_SEE_DETAILS: 'https://phemex.com/announcements/introducing-the-pulse-new-era-mystery-boxes-enhanced-interface-and-more',
  WEB3_PULSE_BIND_DETAIL: 'https://phemex.com/announcements/pulse-as-an-individual-product',
  WEB3_PULSE_INDIVIDUAL_PRODUCT: 'https://phemex.com/announcements/pulse-as-an-individual-product',
  PULSE_SITE: 'https://pulse.social/pulse/',
};

const CMS_WHITE_LIST = [
  '/support',
  '/blogs',
  '/user-guides',
  '/getting-started',
  '/help-center',
  '/academy',
  '/announcements',
  '/help-center/phemex-privacy-policy',
  '/help-center/assets-security',
  '/help-center/withdrawal-process',
  '/help-center/how-do-i-enable-google-two-factor-authentication',
  '/help-center/phemex-terms-of-use',
  '/help-center/1885',
  '/help-center/what-is-the-phemex-otc-service',
  '/help-center/how-do-i-make-a-deposit',
  '/blogs/spot-trading-vs-futures-trading',
  '/blogs/bitcoin-margin-trading-on-phemex',
  '/blogs/hodl-meaning-how-to-hodl',
  '/academy/how-to-trade-crypto',
  '/academy/dyor-do-your-own-research',
  '/announcements/listing-application',
  '/announcements/listing-suggestions',
  '/help-center/what-is-kyc-on-phemex-identity-verification',
  '/help-center/how-to-use-futures-grid-trading-bots-on-phemex-web',
  '/announcements/updates-on-phemex-token-launch-and-xpt-pre-mining-stage-4',
  '/help-center/how-can-i-set-my-spot-grid-trading-bot-on-phemex-web',
  '/academy/what-is-copy-trading',
  '/help-center/phemex-user-copy-trade-agreement',
  '/help-center/copy-trade-profit-sharing-rules',
  '/help-center/what-are-initial-and-maintenance-margins',
];

fixReferences(LINKS);

/**
 * 修正测试网 references 地址
 * TODO: 移除
 * @param LINKS
 */
function fixReferences(LINKS) {
  if (!process.browser || !envUtil.isTestNet) {
    return;
  }

  Object.keys(LINKS).forEach((name) => {
    const link = LINKS[name];
    if (CMS_WHITE_LIST.indexOf(link) > -1) {
      LINKS[name] = window.location.origin.replace('testnet.', '') + link;
    }
  });
}
